import React from 'react'
import Footer from './Footer'
import Navbar from './Navbar'

export default function Toys() {
  return (
    <>
      <Navbar />
      <Footer />
    </>
  )
}
